import { gql } from '@apollo/client';

export const SEND_DIGITAL_DOCUMENT = gql`
  mutation SEND_DIGITAL_DOCUMENT($email: String!, $appointmentId: String!) {
    isSent: sendDigitalDocument(email: $email, appointmentId: $appointmentId)
  }
`;
